import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const userVerificationApiService = createApi({
  reducerPath: "userVerificationApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createUserVerification: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `userverification/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    updateUserVerification: builder.mutation({
      query: ({ id, payload, params }) => {
        let query = queryParams(params);
        return {
          url: `userverification/update/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateUserVerificationMutation,
  useUpdateUserVerificationMutation,
} = userVerificationApiService;
